<template>
  <div id="wrapper">
    <div id="content-wrapper">
      <div class="container-fluid">
        <div class="mb-4">
          <a href="#" @click.prevent="goBack">
            <i class="fas fa-arrow-left"></i>
            Back to Assets List
            <!-- trở về danh sách tài sản -->
          </a>
        </div>
        <div class="row">
          <div class="col-4">
            <b-form @submit.prevent="addItem" class="form-inline mb-3">
              <b-form-select
                id="selectDepartment"
                autocomplete="false"
                style="width: 100%"
                class="mb-3"
                placeholder="Owned Company"
                v-model="department_selected"
                :options="departments"
                value-field="id"
                text-field="tendonvi"
                required
              >
              </b-form-select>
              <b-form-input
                type="text"
                class="form-control mr-4"
                placeholder="Area Title"
                v-model="added_item_name"
                style="width: 80%"
                required
              />
              <button class="btn btn-info" type="submit">
                <i class="fas fa-plus"></i>
                Add
                <!-- Thêm -->
              </button>
            </b-form>
            <b-table
              id="my-table"
              bordered
              head-variant="dark"
              hover
              responsive
              striped
              small
              table-variant="light"
              selectable
              select-mode="single"
              @row-selected="onRowSelected"
              :fields="fields"
              :items="items"
            >
              <template v-slot:cell(name)="data">
                <input
                  type="text"
                  class="form-control"
                  :value="data.item.name"
                  required
                  @change="updateName(data, $event)"
                />
              </template>
              <template v-slot:cell(departmentId)="data">
                <b-form-select
                  class="form-control"
                  :value="data.item.departmentId"
                  :options="departments"
                  value-field="id"
                  text-field="tendonvi"
                  required
                  @change="updateDepartment(data, $event)"
                />
              </template>
              <template v-slot:cell(action)="data">
                <button class="btn btn-danger" @click="deleteItem(data)">
                  <i class="fas fa-trash-alt"></i>
                </button>
              </template>
            </b-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";

export default {
  name: "AssetTypes",
  components: {
    //Multiselect,
  },
  data() {
    return {
      asset_search: "",
      fields: [
        {
          key: "name",
          label: "Area Title",
          // label: "Tên khu vực",
        },
        {
          key: "departmentId",
          label: "Owned Company",
          // label: "Tên đơn vị phụ thuộc",
        },
        {
          key: "action",
          label: "",
          thStyle: { width: "50px !important" },
        },
      ],

      storeItem: {
        id: 0,
        DepartmentId: 0,
        Name: null,
        FullName: null,
        Notes: null,
      },

      departments: [],
      department_selected: null,
      items: [],
      added_item_name: "",
    };
  },

  methods: {
    initData(departments, rooms, params /*Search query from Asset Menu*/) {
      this.asset_search = params.search;
      this.departments = departments;
      this.items = rooms;
    },

    addItem() {
      var isItemExist = this.items.filter(
        (x) =>
          x.Name == this.added_item_name &&
          x.departmentId == this.department_selected
      );
      if (isItemExist.length > 0)
        this.$toast.error("The name already exists", "Error", {
          timeout: 2000,
        });
      else {
        axios
          .post("/api/Room", {
            name: this.added_item_name,
            departmentId: this.department_selected,
          })
          .then((res) => {
            this.items.push(res.data);
            this.department_selected = null;
            this.added_item_name = "";
            this.$toast.success("Add successfully", "Success", {
              timeout: 2000,
            });
          })
          .catch((err) => {
            this.$toast.error(err.response.data, "Error", { timeout: 3000 });
            this.added_item_name = "";
          });
      }
    },

    deleteItem(data) {
      this.$toast.question("Do you really want to delete?", "Warning", {
        timeout: 20000,
        close: false,
        overlay: true,
        displayMode: "once",
        position: "center",
        buttons: [
          [
            "<button><b>Có</b></button>",
            (instance, toast) => {
              axios
                .delete(`api/Room/${data.item.id}`)
                .then((res) => {
                  this.items.splice(data.index, 1);
                  this.$toast.success("Xóa thành công !", "Thành công", {
                    timeout: 3000,
                  });
                })
                .catch((err) => {
                  this.$toast.error(err.response.data, "Lỗi", {
                    timeout: 3000,
                  });
                });
              instance.hide({ transitionOut: "fadeOut" }, toast, "button");
            },
            true,
          ],
          [
            "<button>Không</button>",
            function(instance, toast) {
              instance.hide({ transitionOut: "fadeOut" }, toast, "button");
            },
          ],
        ],
      });
    },

    updateName(data, event) {
      var new_name = event.target.value;
      if (new_name == "")
        this.$toast.error("Please input full information", "Error", {
          timeout: 3000,
        });
      else {
        this.storeItem.id = data.item.id;
        this.storeItem.Name = new_name;
        this.storeItem.DepartmentId = data.item.departmentId;

        axios
          .put("/api/Room", this.storeItem)
          .then((res) => {
            this.$toast.success("Update successfully", "Success", {
              timeout: 3000,
            });
            this.items[data.index].name = new_name;
          })
          .catch((err) => {
            this.$toast.error(err.response.data, "Error", { timeout: 3000 });
            event.target.value = data.item.name;
          });
      }
    },

    updateDepartment(data, event) {
      var new_department = event;

      this.storeItem.id = data.item.id;
      this.storeItem.Name = data.item.name;
      this.storeItem.DepartmentId = new_department;

      axios
        .put("/api/Room", this.storeItem)
        .then((res) => {
          this.$toast.success("Update successfully", "Success", {
            timeout: 3000,
          });
          this.items[data.index].departmentId = new_department;
        })
        .catch((err) => {
          this.$toast.error(err.response.data, "Error", { timeout: 3000 });
          event.target.value = data.item.name;
        });
    },

    goBack() {
      // this.$router.go(-1);
      this.$router.push({
        name: "asset",
        params: { q: this.asset_search },
      });
    },
  },

  beforeRouteEnter(to, from, next) {
    axios.all([axios.get("/api/department"), axios.get("/api/room")]).then(
      axios.spread((department, room) => {
        next((vm) => vm.initData(department.data, room.data, to.params));
      })
    );
  },
};
</script>
